<style scoped>
    .oauth__flex_providers {
        display: flex;
        margin-top: 1rem;
        flex-direction: column;
        text-align: center;
        justify-content: center;
    }

    .oauth__flex_providers > div {
        border: 1px solid #ccc;
        border-radius: 5px;
        margin: 0.2rem 0;
        cursor: pointer;
        color: #161621;
        padding: 0.1rem;
        background-color: #FFF;
    }

    .oauth__flex_providers > div:hover {
        background-color: #f5f5f5;
    }
</style>
<template>
    <div class="oauth__flex_providers">
        <div @click="openLink(provider.redirectTo)" v-for="(provider, index) in providers" :key="index" :title="'Continúa con ' + provider.name">
            <svg v-if="provider.provider === 'azure'" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 48 48" fill="none"> <path d="M0 0h48v48H0z"/> <path fill="#F25022" d="M10 10h13.263v13.263H10z"/> <path fill="#00A4EF" d="M10 24.737h13.263V38H10z"/> <path fill="#7FBA00" d="M24.737 10H38v13.263H24.737z"/> <path fill="#FFB900" d="M24.737 24.737H38V38H24.737z"/> </svg>
            <svg v-else-if="provider.provider === 'google'" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 48 48" fill="none"> <path d="M0 0h48v48H0z"/> <path d="M39.057 24.353c0-1.315-.106-2.275-.335-3.27H23.845v5.937h8.733c-.176 1.475-1.127 3.697-3.24 5.19l-.03.199 4.705 3.679.326.033c2.992-2.791 4.718-6.897 4.718-11.768z" fill="#4285F4"/><path d="M23.845 39.996c4.278 0 7.87-1.422 10.493-3.875l-5-3.911c-1.338.942-3.134 1.6-5.493 1.6-4.19 0-7.746-2.79-9.014-6.648l-.186.016L9.754 31l-.064.18c2.606 5.225 7.958 8.816 14.155 8.816z" fill="#34A853"/> <path d="M14.831 27.162a9.935 9.935 0 0 1-.528-3.164c0-1.102.193-2.169.51-3.164l-.008-.212-4.953-3.883-.162.078A16.139 16.139 0 0 0 8 23.997c0 2.578.616 5.014 1.69 7.182l5.141-4.017z" fill="#FBBC05"/> <path d="M23.845 14.186c2.975 0 4.983 1.297 6.127 2.382l4.472-4.409C31.697 9.582 28.124 8 23.845 8c-6.197 0-11.55 3.59-14.155 8.817l5.123 4.017c1.286-3.857 4.842-6.648 9.032-6.648z" fill="#EB4335"/> </svg>
            <svg v-else-if="provider.provider === 'github'" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 48 48" fill="none"><path d="M0 0h48v48H0z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23.998 8C15.165 8 8 15.135 8 23.937c0 7.04 4.584 13.013 10.942 15.12.8.147 1.092-.345 1.092-.768 0-.377-.014-1.38-.021-2.71-4.45.963-5.39-2.136-5.39-2.136-.728-1.841-1.777-2.331-1.777-2.331-1.452-.988.11-.969.11-.969 1.606.113 2.451 1.643 2.451 1.643 1.427 2.435 3.745 1.731 4.657 1.323.145-1.029.559-1.731 1.015-2.13-3.552-.401-7.288-1.77-7.288-7.876 0-1.74.624-3.163 1.647-4.276-.165-.403-.714-2.024.158-4.218 0 0 1.342-.428 4.399 1.634A15.378 15.378 0 0 1 24 15.706c1.36.007 2.728.183 4.006.537 3.055-2.062 4.395-1.633 4.395-1.633.874 2.193.325 3.814.16 4.217 1.026 1.113 1.645 2.537 1.645 4.276 0 6.122-3.742 7.47-7.305 7.864.574.492 1.085 1.464 1.085 2.951 0 2.13-.02 3.85-.02 4.371 0 .427.29.923 1.1.767C35.42 36.944 40 30.977 40 23.937 40 15.136 32.836 8 23.998 8z" fill="#161514"/></svg>
            Continúa con {{ provider.name }}
        </div>
    </div>
</template>
<script>
export default {
    name: 'oauth-login-with-btn',
    props: {
        providers: {
            type: Array,
            required: true
        },
    },
    methods: {
        openLink(redirectTo) {
            window.location.href = redirectTo;
        }
    }
}
</script>